<template>
  <div class="dynamics" id="home-dynamics">
    <!-- 类目遍历 -->
    <div
      v-for="(item, itemIndex) in homepageList"
      :key="itemIndex"
      :id="'a' + itemIndex"
    >
      <template v-if="item.templateCode === 2">
        <div class="area-top">
          <div class="t1">{{ item.titleName }}</div>
        </div>
        <div class="area">
          <el-carousel class="banner" arrow="never">
            <el-carousel-item
              v-for="(v, i) in item.homePageAdvertisementInfoVoList || []"
              :key="i"
              class="banner-item pointer"
            >
              <el-image
                class="banner-item"
                :src="v.photoUrl || defaultImg"
                @click="bannerHandle(v)"
              >
                <div slot="error">
                  <el-image class="img" :src="defaultImg" :fit="'cover'">
                  </el-image>
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="goodsList2">
            <div
              v-for="(g, index) in (
                item.homePageCategoryCommodityVoList || []
              ).slice(0, 8)"
              :key="index"
              @click="goodDetail(g.commoditySpuVo.spuId)"
            >
              <GoodCard :dataSource="g" class="mb-12 mr-9 pointer2"></GoodCard>
            </div>
          </div>
          <div
            class="brand-list"
            v-if="
              item.homePageAdvertisementBrandVoList &&
              item.homePageAdvertisementBrandVoList.length
            "
          >
            <el-image
              class="brand-item pointer2"
              lazy
              :src="v.brandUrl || defaultImg"
              :fit="'contain'"
              v-for="(v, i) in item.homePageAdvertisementBrandVoList.slice(
                0,
                4
              ) || []"
              :key="i"
              @click="getgoodsByBrand(v.brandId)"
            >
              <div slot="error">
                <el-image class="img" :src="defaultImg" :fit="'contain'">
                </el-image>
              </div>
            </el-image>
          </div>
        </div>
      </template>
      <template v-if="[3, 4].includes(item.templateCode)">
        <div class="area-top">
          <div class="t1">{{ item.titleName }}</div>
          <div class="flex-end">
            <div
              class="titleBtn"
              :class="{ active: showCategoryIndex[itemIndex] === index }"
              v-for="(c, index) in item.homePageCategoryCommodityVoList || []"
              :key="index"
              @click="setCategoryIndex(itemIndex, index)"
            >
              {{ c.categoryName }}
            </div>
            <div v-show="[4].includes(item.templateCode)" class="titleBtn" v-if="item.homePageCategoryCommodityVoList[showCategoryIndex[itemIndex]].categoryId" @click="toMore(item.homePageCategoryCommodityVoList[showCategoryIndex[itemIndex]])">更多</div>
          </div>
        </div>
        <div class="area">
          <el-carousel class="banner" arrow="never">
            <el-carousel-item
              v-for="(v, i) in item.homePageAdvertisementInfoVoList || []"
              :key="i"
              class="banner-item pointer"
            >
              <el-image
                class="banner-item"
                :src="v.photoUrl || defaultImg"
                @click="bannerHandle(v)"
              >
                <div slot="error">
                  <el-image class="img" :src="defaultImg" :fit="'cover'">
                  </el-image>
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="goodsList">
            <div
              v-for="(g, index) in (
                item.homePageCategoryCommodityVoList[
                  showCategoryIndex[itemIndex]
                ].children || []
              ).slice(0, 10)"
              :key="index"
              @click="goodDetail(g.commoditySpuVo.spuId)"
            >
              <GoodCard :dataSource="g" class="mb-12 mr-9 pointer2"></GoodCard>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import GoodCard from './goodCard.vue'
import { openOther } from '@/utils/index'

export default {
  components: { GoodCard },
  data () {
    return {
      homepageList: [],
      showCategoryIndex: [],
      defaultImg: require('@/assets/img/bitmap.png')
    }
  },
  created () {
    this.getHomepageList()
  },
  methods: {
    toMore (v) {
      this.bus.$emit('setHeaderSearchName', '')
      this.$router.push({
        name: 'goodSearchCategoryList',
        query: {
          search: '',
          foregroundCategoryId: v.categoryId,
          brandIdList: '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false
        }
      })
    },
    // 进入商品详情页
    goodDetail (spuId) {
      // console.log(res.commoditySpuVo.spuId);
      if (!spuId) {
        return
      }
      openOther(`goodDetail?spuId=${spuId}`)
    },
    setCategoryIndex (itemIndex, index) {
      this.$set(this.showCategoryIndex, itemIndex, index)
    },
    getHomepageList () {
      this.$request
        .postParam(`/front/user/home/homePageAdvertisement/selectAllDatas`, {
          mobiled: false
        })
        .then((data) => {
          let homepageList = data || []
          // let aIndex = []
          homepageList.forEach((item, index) => {
            item.homeOneTabIndex = item.homePageCategoryCommodityVoList.length
              ? 0
              : -1
            item.showFirstGoods = this.showFirstGoods(item)
            this.$set(item, 'floIndexac', 0)
          })
          this.homepageList = homepageList.filter((i) => {
            return [2, 3, 4].includes(i.templateCode)
          })

          this.showCategoryIndex = Array.from(
            { length: this.homepageList.length },
            () => 0
          )
          console.log(this.homepageList)

          this.$emit('setHomepageList', this.homepageList)
        })
    },
    showFirstGoods (item) {
      let catGoodData = item.homePageCategoryCommodityVoList
      if (!(catGoodData && catGoodData.length)) {
        return []
      }
      let num = item.templateCode === 1 ? 4 : 8
      if (item.homeOneTabIndex && item.homeOneTabIndex > -1) {
        return catGoodData[item.homeOneTabIndex].children &&
          catGoodData[item.homeOneTabIndex].children.length
          ? catGoodData[item.homeOneTabIndex].children.slice(0, num)
          : []
      } else {
        return catGoodData[0].children && catGoodData[0].children.length
          ? catGoodData[0].children.slice(0, num)
          : []
      }
    },
    getgoodsByBrand (brandId) {
      this.$router.push({
        name: 'goodSearchCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    bannerHandle (v) {
      console.log(v)
      if (v.linkUrl) {
        window.open(v.linkUrl, '_blank')
      } else {
        this.goodDetail(v.commoditySpuId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dynamics {
  .area {
    display: flex;
  }
  .t1 {
    font-family: Alimama ShuHeiTi;
    font-size: 24px;
    font-weight: 700;
    line-height: 29.42px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #333;
  }
  .banner {
    width: 190px;
    height: 570px;
    border-radius: 16px;
    // padding: 32px;
    margin-right: 12px;
    flex-shrink: 0;
    .banner-item {
      width: 190px;
      height: 570px;
    }
  }
  .titleBtn {
    border-radius: 8px;
    padding: 6px 16px;
    font-family: Alibaba PuHuiTi;
    font-size: 13px;
    font-weight: 400;
    // line-height: 34px;
    text-align: center;
    color: #666;
    background: #fff;
    border: 1px solid #fff;
    cursor: pointer;
    &:hover {
      color: #2a54d1;
    }
    &.active {
      color: #2a54d1;
      font-weight: 700;
      border: 1px solid #2a54d1;
    }
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-12 {
    margin-bottom: 12px;
  }
  .mr-9 {
    margin-right: 9px;
  }
  .goodsList {
    width: 988;
    display: flex;
    flex-wrap: wrap;
  }
  .goodsList2 {
    width: 800px;
    display: flex;
    flex-wrap: wrap;
  }
  .area-top {
    margin: 40px 0 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .brand-list {
    width: 190px;
    display: flex;
    flex-direction: column;
    .brand-item {
      width: 190px;
      height: 134px;
      border: 2px solid #f6f5fa;
      border-radius: 16px;
      margin-bottom: 12px;
    }
  }
}
</style>
